import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import MyInvoisActions from '../MyInvois/actions';
import {deleto, get, patch, post, puto} from 'bukku/shared/ApiService';
import {plural, t, Trans} from "@lingui/macro";
import { windowOpenPopUpFallback } from '../../helpers/windowOpenPopUpFallback';
import React from 'react';
import { showBatchImportModalError } from '../helper';
import { store } from '../store';

// Create contact
export function* createContactRequest() {
    yield takeEvery(actions.CREATE_CONTACT_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/contacts', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_CONTACT_SUCCESS,
                contact: data.contact,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_CONTACT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createContactSuccess() {
    yield takeEvery(actions.CREATE_CONTACT_SUCCESS, function* () {
        yield message.success(t`The contact is created.`);
    });
}
export function* createContactError() {
    yield takeEvery(actions.CREATE_CONTACT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Import contacts
export function* importContactsRequest() {
    yield takeEvery(actions.IMPORT_CONTACTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/contacts/batch', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.IMPORT_CONTACTS_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.IMPORT_CONTACTS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* importContactsSuccess() {
    yield takeEvery(actions.IMPORT_CONTACTS_SUCCESS, function* ({ data }) {
        yield message.success(
            t`${data.created_count} contacts created and ${data.updated_count} contacts updated.`,
        );
    });
}
export function* importContactsError() {
    yield takeEvery(actions.IMPORT_CONTACTS_ERROR, function* ({ error }) {
        // yield message.error(error.message);
        const { Contact } = store.getState();

        yield showBatchImportModalError(error, Contact.importHeaderRowLineCount, t`contacts`);
    });
}

// Bulk Update contacts
export function* bulkUpdateContactsRequest() {
    yield takeEvery(actions.BULK_UPDATE_CONTACTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, '/contacts/bulk_contact', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.BULK_UPDATE_CONTACTS_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.BULK_UPDATE_CONTACTS_ERROR,
                error,
                errors: error.errors,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* bulkUpdateContactsSuccess() {
    yield takeEvery(actions.BULK_UPDATE_CONTACTS_SUCCESS, function* ({ data }) {
        const {updated_count} = data;
        const successMsg = plural(updated_count, {
            one: `1 contact updated`,
            other: `# contact(s) updated`,
        });

        yield message.success(successMsg);
    });
}
export function* bulkUpdateContactsError() {
    yield takeEvery(actions.BULK_UPDATE_CONTACTS_ERROR, function* ({ error }) {
        if (!error.errors || Object.keys(error.errors).length === 0)
            yield message.error(error.message);
    });
}

// Bulk Delete contacts
export function* bulkDeleteContactsRequest() {
    yield takeEvery(actions.BULK_DELETE_CONTACTS_REQUEST, function* ({ request}) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(deleto, '/contacts/bulk_contact', request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.BULK_DELETE_CONTACTS_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.BULK_DELETE_CONTACTS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* bulkDeleteContactsSuccess() {
    yield takeEvery(actions.BULK_DELETE_CONTACTS_SUCCESS, () => {});
}
export function* bulkDeleteContactsError() {
    yield takeEvery(actions.BULK_DELETE_CONTACTS_ERROR, () => {});
}

// Read Bulk Contacts
export function* readBulkContactsRequest() {
    yield takeEvery(actions.READ_BULK_CONTACTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/contacts/bulk_contact', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_BULK_CONTACTS_SUCCESS,
                contacts: data.contacts,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_BULK_CONTACTS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readBulkContactsSuccess() {
    yield takeEvery(actions.READ_BULK_CONTACTS_SUCCESS, () => {});
}
export function* readBulkContactsError() {
    yield takeEvery(actions.READ_BULK_CONTACTS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    },
    );
}

// Read contacts
export function* readContactsRequest() {
    yield takeEvery(actions.READ_CONTACTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/contacts', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_CONTACTS_SUCCESS,
                contacts: data.contacts,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_CONTACTS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readContactsSuccess() {
    yield takeEvery(actions.READ_CONTACTS_SUCCESS, () => {});
}
export function* readContactsError() {
    yield takeEvery(actions.READ_CONTACTS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read contact
export function* readContactRequest() {
    yield takeEvery(actions.READ_CONTACT_REQUEST, function* ({ id, forceHideFilePreview }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/contacts/${id}`, null, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_CONTACT_SUCCESS,
                contact: data.contact,
                forceHideFilePreview, // contact list page, click quickshare drawer will also readContact, but on that successs, don't show file preview
            });

            yield put({
                type: MyInvoisActions.MYINVOIS_SET_VALIDATE_TIN_REG_NO_RESULT,
                // It's null if it's not validated due to entity type = Foreign company/exmepted person, OR is individual but only one of reg_no/TIN is field.
                // If that's the case, treat it as valid because we want to show the tick icon
                isValid: data.contact.is_myinvois_validated === null ? true
                    : data.contact.is_myinvois_validated,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_CONTACT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readContactSuccess() {
    yield takeEvery(actions.READ_CONTACT_SUCCESS, () => {});
}
export function* readContactError() {
    yield takeEvery('READ_CONTACT_ERROR', function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read contact statement
export function* readContactStatementRequest() {
    yield takeEvery(actions.READ_CONTACT_STATEMENT_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/contacts/${id}/statement`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_CONTACT_STATEMENT_SUCCESS,
                statement: data.statement,
                contact: data.contact,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_CONTACT_STATEMENT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readContactStatementSuccess() {
    yield takeEvery(actions.READ_CONTACT_STATEMENT_SUCCESS, () => {});
}
export function* readContactStatementError() {
    yield takeEvery(actions.READ_CONTACT_STATEMENT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update contact
export function* updateContactRequest() {
    yield takeEvery(actions.UPDATE_CONTACT_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, `/contacts/${id}`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.UPDATE_CONTACT_SUCCESS,
                contact: data.contact,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_CONTACT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateContactSuccess() {
    yield takeEvery(actions.UPDATE_CONTACT_SUCCESS, function* () {
        yield message.success(t`The contact is updated.`);
    });
}
export function* updateContactError() {
    yield takeEvery(actions.UPDATE_CONTACT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Archive contact
export function* archiveContactRequest() {
    yield takeEvery(actions.ARCHIVE_CONTACT_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(patch, `/contacts/${id}`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.ARCHIVE_CONTACT_SUCCESS,
                contact: data.contact,
            });
        }
        catch (error) {
            yield put({
                type: actions.ARCHIVE_CONTACT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* archiveContactSuccess() {
    yield takeEvery(actions.ARCHIVE_CONTACT_SUCCESS, function* ({ contact }) {
        yield message.success(
            contact.is_archived ? t`The contact is deactivated.` : t`The contact is activated.`,
        );
    });
}
export function* archiveContactError() {
    yield takeEvery(actions.ARCHIVE_CONTACT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete contact
export function* deleteContactRequest() {
    yield takeEvery(actions.DELETE_CONTACT_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/contacts/${id}`, null, context);

            yield put({
                type: actions.DELETE_CONTACT_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_CONTACT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteContactSuccess() {
    yield takeEvery(actions.DELETE_CONTACT_SUCCESS, function* () {
        yield message.success(t`The contact is deleted.`);
    });
}
export function* deleteContactError() {
    yield takeEvery(actions.DELETE_CONTACT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}
// Send email statement of accounts
export function* sendEmailRequest() {
    yield takeEvery(actions.SEND_EMAIL_STATEMENT_REQUEST, function* ({
        id, request,
    }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, `/contacts/${id}/statement/email`, request, context);

            yield put({
                type: actions.SEND_EMAIL_STATEMENT_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.SEND_EMAIL_STATEMENT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* sendEmailSuccess() {
    yield takeEvery(actions.SEND_EMAIL_STATEMENT_SUCCESS, function* () {
        yield message.success(t`The email is sent.`);
    });
}
export function* sendEmailError() {
    yield takeEvery(actions.SEND_EMAIL_STATEMENT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* sendMyInvoisEmailRequest() {
    yield takeEvery(actions.SEND_MYINVOIS_INFO_REQUEST, function* ({ id, emails }) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, `/contacts/${id}/myinvois_ready_requests`, { type: "EMAIL", emails });
            yield put({
                type: actions.SEND_MYINVOIS_INFO_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.SEND_MYINVOIS_INFO_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* sendMyInvoisEmailSuccess() {
    yield takeEvery(actions.SEND_MYINVOIS_INFO_SUCCESS, function* () {
        yield message.success(t`The request email is sent.`);
    });
}
export function* sendMyInvoisEmailError() {
    yield takeEvery(actions.SEND_MYINVOIS_INFO_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* getMyInvoisUrlRequest() {
    yield takeEvery(actions.GET_MYINVOIS_INFO_REQUEST, function* ({ id }) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(post, `/contacts/${id}/myinvois_ready_requests`, { type: "LINK" });
            const data = yield response.data;
            yield put({
                type: actions.GET_MYINVOIS_INFO_SUCCESS,
                link: data.link,
            });
        }
        catch (error) {
            yield put({
                type: actions.GET_MYINVOIS_INFO_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* getMyInvoisUrlSuccess() {
    yield takeEvery(actions.GET_MYINVOIS_INFO_SUCCESS, function* () {
        // yield message.success(t`The request email is sent.`);
    });
}
export function* getMyInvoisUrlError() {
    yield takeEvery(actions.GET_MYINVOIS_INFO_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* bulkSendMyInvoisEmailRequest() {
    yield takeEvery(actions.BULK_SEND_MYINVOIS_INFO_REQUEST, function* ({request}) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, `/contacts/myinvois_ready_requests`, request);
            const data = yield response.data;

            yield put({
                type: actions.BULK_SEND_MYINVOIS_INFO_SUCCESS,
                skippedIds: data.skipped_ids,
            });
        }
        catch (error) {
            yield put({
                type: actions.BULK_SEND_MYINVOIS_INFO_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* bulkSendMyInvoisEmailSuccess() {
    yield takeEvery(actions.BULK_SEND_MYINVOIS_INFO_SUCCESS, function* () {
        yield message.success(t`The request emails are sent.`);
    });
}
export function* bulkSendMyInvoisEmailError() {
    yield takeEvery(actions.BULK_SEND_MYINVOIS_INFO_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// view single pdf
export function* exportStatementRequest() {
    yield takeEvery(actions.EXPORT_STATEMENT_REQUEST, function* ({
        id, exportType, request,
    }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(post, `/contacts/${id}/statement/${exportType}`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.EXPORT_STATEMENT_SUCCESS,
                statementWithRemarks: data.public_url,
            });
        }
        catch (error) {
            yield put({
                type: actions.EXPORT_STATEMENT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* exportStatementSuccess() {
    yield takeEvery(actions.EXPORT_STATEMENT_SUCCESS, function* () {
        yield message.success(t`Statement of account is generated.`);
    });
}
export function* exportStatementError() {
    yield takeEvery(actions.EXPORT_STATEMENT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// view single pdf
export function* getStatementLinkRequest() {
    yield takeEvery(actions.GET_STATEMENT_LINK_REQUEST, function* ({
        id, request,
    }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(post, `/contacts/${id}/statement/url`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.GET_STATEMENT_LINK_SUCCESS,
                shareStatementLink: data.share_url,
            });
        }
        catch (error) {
            yield put({
                type: actions.GET_STATEMENT_LINK_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* getStatementLinkSuccess() {
    yield takeEvery(actions.GET_STATEMENT_LINK_SUCCESS, function* () {
    // yield message.success(t`Statement of account link is generated.`);
    });
}
export function* getStatementLinkError() {
    yield takeEvery(actions.GET_STATEMENT_LINK_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// view bulk pdf
export function* createPdfsRequest() {
    yield takeEvery(actions.CREATE_PDFS_REQUEST, function* ({request}, context) {
        const msgKey = Math.random().toString();
        const msgConfig = {
            key: msgKey,
            type: "loading",
            content: t`Generating PDFs...`,
            duration: 0,
            // className: "",
        };

        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            message.open(msgConfig); // Show a message that the PDFs are loading

            const response = yield call(post, '/contacts/statements/pdf', request, context);
            const data = yield response.data;

            message.destroy(msgKey); // close the message when pdf loaded
            // window.open(data.public_url); // open the merged pdfs in a new tab
            windowOpenPopUpFallback(
                data.public_url,
                t`Statement of Account PDFs Generated`,
                <Trans>
                    Your Statement of Account has been generated.
                    Click OK to view/download.
                </Trans>,
            );

            yield put({
                type: actions.CREATE_PDFS_SUCCESS,
                data,
                msgKey,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_PDFS_ERROR,
                error,
                msgKey,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createPdfsSuccess() {
    yield takeEvery(actions.CREATE_PDFS_SUCCESS, () => {});
}
export function* createPdfsError() {
    yield takeEvery(actions.CREATE_PDFS_ERROR, function* ({ error, msgKey }) {
    // yield message.error("Error Creating Bulk PDFs:", error.message);
        message.destroy(msgKey); // close the generating pdf message when error has been encountered
        if (!error.canSuppress)
            yield message.error(t`Fail to generate PDFs: ${error.message}`);
    });
}

// send bulk email
export function* sendBulkEmailStatementRequest() {
    yield takeEvery(actions.SEND_BULK_EMAIL_STATEMENT_REQUEST, function* ({request}, context) {
        const msgKey = Math.random().toString();
        const msgConfig = {
            key: msgKey,
            type: "loading",
            content: t`Sending Emails...`,
            duration: 0,
            // className: "",
        };

        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            message.open(msgConfig); // Show a message that the email are loading

            const response = yield call(post, '/contacts/statements/email', request, context);
            const data = yield response.data;
            message.destroy(msgKey);// close the message when email sent loaded

            yield put({
                type: actions.SEND_BULK_EMAIL_STATEMENT_SUCCESS,
                data,
                msgKey,
            });
        }
        catch (error) {
            yield put({
                type: actions.SEND_BULK_EMAIL_STATEMENT_ERROR,
                error,
                msgKey,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* sendBulkEmailStatementSuccess() {
    yield takeEvery(actions.SEND_BULK_EMAIL_STATEMENT_SUCCESS, function* () {
        yield message.success(t`The email is sent.`);
    });
}
export function* sendBulkEmailStatementError() {
    yield takeEvery(actions.SEND_BULK_EMAIL_STATEMENT_ERROR, function* ({ error, msgKey }) {
    // yield message.error("Error Creating Bulk PDFs:", error.message);
        message.destroy(msgKey); // close the generating pdf message when error has been encountered
        if (!error.canSuppress)
            yield message.error(t`Fail to send PDF to emails ${error.message}`);
    });
}

// Merge Contacts
export function* mergeContactsRequest() {
    yield takeEvery(actions.CONTACTS_MERGE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/contacts/merge', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CONTACTS_MERGE_SUCCESS,
                request,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACTS_MERGE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* mergeContactsSuccess() {
    yield takeEvery(actions.CONTACTS_MERGE_SUCCESS, function* ({ request, data }) {
        yield message.success(
            t`${request.merge_contact_ids.length} contacts merged into ${data.contact.legal_name}`,
        );
    });
}
export function* mergeContactsError() {
    yield takeEvery(actions.CONTACTS_MERGE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// READ ALL Mandates
export function* readMandatesRequest() {
    yield takeEvery(actions.GET_MANDATES_REQUEST, function* ({ request }) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/contacts/mandates', request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.GET_MANDATES_SUCCESS,
                pagination: data.paging,
                mandates: data.mandates,
            });
        }
        catch (error) {
            yield put({
                type: actions.GET_MANDATES_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readMandatesSuccess() {
    yield takeEvery(actions.GET_MANDATES_SUCCESS, () => {});
}
export function* readMandatesError() {
    yield takeEvery(actions.GET_MANDATES_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// READ CONTACT'S Mandates
export function* readContactMandateRequest() {
    yield takeEvery(actions.READ_CONTACT_MANDATE_REQUEST, function* ({ id, request }) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/contacts/${id}/mandates`, request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_CONTACT_MANDATE_SUCCESS,
                mandate: data,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_CONTACT_MANDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readContactMandateSuccess() {
    yield takeEvery(actions.READ_CONTACT_MANDATE_SUCCESS, () => {});
}
export function* readContactMandateError() {
    yield takeEvery(actions.READ_CONTACT_MANDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// CREATE CONTACT'S Mandates
export function* createContactMandateRequest() {
    yield takeEvery(actions.CREATE_CONTACT_MANDATE_REQUEST, function* ({ id, request }) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, `/contacts/${id}/mandates`, request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_CONTACT_MANDATE_SUCCESS,
                // pagination: data.paging,
                mandates: data.mandates,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_CONTACT_MANDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createContactMandateSuccess() {
    yield takeEvery(actions.CREATE_CONTACT_MANDATE_SUCCESS, function* () {
        yield message.success(t`Mandate successfully created`);
    });
}
export function* createContactMandateError() {
    yield takeEvery(actions.CREATE_CONTACT_MANDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// UPDATE CONTACT'S Mandates
export function* updateContactMandateRequest() {
    yield takeEvery(actions.UPDATE_CONTACT_MANDATE_REQUEST, function* ({ id, request }) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, `/contacts/${id}/mandates`, request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.UPDATE_CONTACT_MANDATE_SUCCESS,
                // pagination: data.paging,
                mandates: data.mandates,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_CONTACT_MANDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateContactMandateSuccess() {
    yield takeEvery(actions.UPDATE_CONTACT_MANDATE_SUCCESS, function* () {
        yield message.success(t`Mandate successfully updated`);
    });
}
export function* updateContactMandateError() {
    yield takeEvery(actions.UPDATE_CONTACT_MANDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// DELETE CONTACT'S Mandates
export function* deleteContactMandateRequest() {
    yield takeEvery(actions.DELETE_CONTACT_MANDATE_REQUEST, function* ({ id }) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/contacts/${id}/mandates`);

            // OK
            yield put({
                type: actions.DELETE_CONTACT_MANDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_CONTACT_MANDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteContactMandateSuccess() {
    yield takeEvery(actions.DELETE_CONTACT_MANDATE_SUCCESS, function* () {
        yield message.success(t`Mandate deleted successfully.`);
    });
}
export function* deleteContactMandateError() {
    yield takeEvery(actions.DELETE_CONTACT_MANDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* searchTINByRegNoAndTypeRequest() {
    yield takeEvery(actions.SEARCH_CONTACT_TIN_REQUEST, function* ({ request }) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/contacts/tin`, request);
            const data = yield response.data;

            yield put({
                type: actions.SEARCH_CONTACT_TIN_SUCCESS,
                tin: data.tin,
            });
        }
        catch (error) {
            yield put({
                type: actions.SEARCH_CONTACT_TIN_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* searchTINByRegNoAndTypeSuccess() {
    yield takeEvery(actions.SEARCH_CONTACT_TIN_SUCCESS, function* () {
        yield message.success(t`TIN found and updated.`);
    });
}

export function* searchTINByRegNoAndTypeError() {
    yield takeEvery(actions.SEARCH_CONTACT_TIN_ERROR, function* () {
        yield message.error('TIN not found');
    });
}

export function* getContactCodeRequest() {
    yield takeEvery(actions.GET_CONTACT_CODE_REQUEST, function* ({ request }) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/contacts/contact_code', request);
            const data = yield response.data;

            yield put({
                type: actions.GET_CONTACT_CODE_SUCCESS,
                contact_code: data?.contact_code,
            });
        }
        catch (error) {
            yield put({
                type: actions.GET_CONTACT_CODE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(createContactRequest),
        fork(createContactSuccess),
        fork(createContactError),
        fork(importContactsRequest),
        fork(importContactsSuccess),
        fork(importContactsError),
        fork(bulkUpdateContactsRequest),
        fork(bulkUpdateContactsSuccess),
        fork(bulkUpdateContactsError),
        fork(readBulkContactsRequest),
        fork(readBulkContactsSuccess),
        fork(readBulkContactsError),
        fork(readContactsRequest),
        fork(readContactsSuccess),
        fork(readContactsError),
        fork(readContactRequest),
        fork(readContactSuccess),
        fork(readContactError),
        fork(readContactStatementRequest),
        fork(readContactStatementSuccess),
        fork(readContactStatementError),
        fork(updateContactRequest),
        fork(updateContactSuccess),
        fork(updateContactError),
        fork(archiveContactRequest),
        fork(archiveContactSuccess),
        fork(archiveContactError),
        fork(deleteContactRequest),
        fork(deleteContactSuccess),
        fork(deleteContactError),
        fork(sendEmailRequest),
        fork(sendEmailSuccess),
        fork(sendEmailError),
        fork(exportStatementRequest),
        fork(exportStatementSuccess),
        fork(exportStatementError),
        fork(createPdfsRequest),
        fork(createPdfsSuccess),
        fork(createPdfsError),
        fork(sendBulkEmailStatementRequest),
        fork(sendBulkEmailStatementSuccess),
        fork(sendBulkEmailStatementError),
        fork(sendMyInvoisEmailRequest),
        fork(sendMyInvoisEmailSuccess),
        fork(sendMyInvoisEmailError),
        fork(getMyInvoisUrlRequest),
        fork(getMyInvoisUrlSuccess),
        fork(getMyInvoisUrlError),
        fork(bulkSendMyInvoisEmailRequest),
        fork(bulkSendMyInvoisEmailSuccess),
        fork(bulkSendMyInvoisEmailError),
        fork(getStatementLinkRequest),
        fork(getStatementLinkSuccess),
        fork(getStatementLinkError),
        fork(mergeContactsRequest),
        fork(mergeContactsSuccess),
        fork(mergeContactsError),
        fork(readMandatesRequest),
        fork(readMandatesSuccess),
        fork(readMandatesError),
        fork(readContactMandateRequest),
        fork(readContactMandateSuccess),
        fork(readContactMandateError),
        fork(createContactMandateRequest),
        fork(createContactMandateSuccess),
        fork(createContactMandateError),
        fork(updateContactMandateRequest),
        fork(updateContactMandateSuccess),
        fork(updateContactMandateError),
        fork(deleteContactMandateRequest),
        fork(deleteContactMandateSuccess),
        fork(deleteContactMandateError),
        fork(searchTINByRegNoAndTypeRequest),
        fork(searchTINByRegNoAndTypeSuccess),
        fork(searchTINByRegNoAndTypeError),
        fork(getContactCodeRequest),
        fork(bulkDeleteContactsRequest),
        fork(bulkDeleteContactsSuccess),
        fork(bulkDeleteContactsError),
    ]);
}
